<template>
  <vh-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="1020px"
    modal
    custom-class="vmp-card-dialog"
    append-to-body
    @open="open"
  >
    <template slot="title">
      <span v-if="!showCreate && !CardClick" class="card-head-title">
        {{ $t('host.k_591001') }}
        <vh-link
          v-show="total > 0"
          type="primary"
          @click="reload"
          :underline="false"
          class="reload"
        >
          {{ $t('host.k_591002') }}
        </vh-link>
      </span>
      <span v-else class="title-container">
        <i
          class="vh-iconfont vh-line-arrow-left cursor-pointer std-color-icon"
          @click="handleChangeView"
        />

        <vh-tooltip effect="dark" :content="title" placement="bottom">
          <span class="std-panel-title m-l-8 dialog-title">
            {{ title }}
          </span>
        </vh-tooltip>
        <template v-if="CardClick">
          <span>{{ $t('host.k_591003') }}</span>
          <vh-tooltip effect="dark" content="" placement="right">
            <div slot="content">
              {{ $t('host.k_591004') }}
              <br />
              {{ $t('host.k_591005') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m m-l-4" />
          </vh-tooltip>
          <vh-link type="primary" @click="reloadClickNum" :underline="false" class="reload">
            {{ $t('host.k_591002') }}
          </vh-link>
        </template>
      </span>
    </template>
    <PushCardList
      ref="pushCards"
      :env="env"
      :webinarId="webinarId"
      :dialogVisible="dialogVisible"
      scene="live"
      :webinarInfor="webinarInfor"
      @showCardAdd="showCardAdd"
      @showCardClick="showCardClick"
      @noticeTotal="noticeTotal"
      v-show="!showCreate && !CardClick"
    />

    <PushCardCreate
      ref="cardCreate"
      :env="env"
      :cardId="cardId"
      :webinarId="webinarId"
      :showCreate="showCreate"
      :sync="configList.hidden_asset_library != 1"
      scene="live"
      :uploadNonToken="uploadNonToken"
      @saveSuccess="saveSuccess"
      v-show="showCreate"
    />
    <ClickCardInfo
      ref="cardClickNum"
      :env="env"
      :webinarId="webinarId"
      scene="live"
      v-show="CardClick"
    />
  </vh-dialog>
</template>
<script>
  import { PushCardList, PushCardCreate, ClickCardInfo } from '@vhcl/push-card';
  import { useMsgServer, useRoomBaseServer, useChatServer } from 'middle-domain';
  export default {
    name: 'VmpCard', // 发起端列表弹窗
    components: {
      PushCardList,
      PushCardCreate,
      ClickCardInfo
    },
    computed: {
      uploadNonToken() {
        // 助理&嘉宾端不传token
        return this.roleName == 3 || this.roleName == 4 ? true : false;
      },
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.roomBaseServer.state.watchInitData.join_info.role_name;
      },
      // 当前用户Id
      userId() {
        return this.roomBaseServer.state.watchInitData.join_info.third_party_user_id;
      },
      // 主讲人权限
      doc_permission() {
        if (this.isInGroup) {
          return this.groupServer.state.groupInitData.doc_permission;
        } else {
          return this.roomBaseServer.state.interactToolStatus.doc_permission;
        }
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      //当前活动部分信息
      webinarInfor() {
        return {
          liveStatus: this.$domainStore.state.roomBaseServer.watchInitData.webinar.type,
          switchId: this.$domainStore.state.roomBaseServer?.watchInitData?.switch.switch_id
        };
      }
    },
    watch: {
      // 主讲人发生变化
      doc_permission() {
        if (this.doc_permission != this.userId) {
          // 如果嘉宾为主讲人: 设置为可用
          this.handleClose();
        }
      }
    },
    provide() {
      return {
        getWatchInitData: () => this.roomBaseServer.state.watchInitData
      };
    },
    filters: {
      overHidden(value = '', len = 0) {
        if (value === null || value === undefined) return '';
        if (value.length > len) {
          return value.substring(0, len) + '...';
        }
        return value;
      }
    },
    data() {
      const { watchInitData = {} } = this.roomBaseServer.state;
      const { webinar = {} } = watchInitData;
      return {
        dialogVisible: false,
        componentView: 'ExamListPanel',
        currentExamId: '', // 当前操作的
        env: process.env.VUE_APP_ENV,
        webinarId: webinar.id,
        showCreate: false,
        CardClick: false,
        cardId: '',
        title: this.cardId ? this.$t('host.k_591006') : this.$t('host.k_591007'),
        cardObj: {},
        total: 0
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.msgServer = useMsgServer();
    },
    async created() {
      this.msgServer.$onMsg('ROOM_MSG', this.handleRoomMsg);
    },
    beforeDestroy() {
      this.msgServer?.$offMsg('ROOM_MSG', this.handleRoomMsg);
    },
    methods: {
      reloadClickNum() {
        this.$refs.cardClickNum.getClickCardList();
      },
      noticeTotal(total) {
        this.total = total;
      },
      showCardAdd(cardObj) {
        // 打开编辑或创建弹窗
        this.cardObj = cardObj;
        this.cardId = cardObj?.id;
        this.setTitle();
        // this.$refs.cardCreate.clear();
        // this.$refs.cardCreate.ini();
        this.showCreate = true;
      },
      showCardClick(cardObj) {
        // 打开点击人数
        this.cardObj = cardObj;
        this.setTitle('clickNum');
        this.CardClick = true;
        this.$refs.cardClickNum.open(cardObj);
      },
      setTitle(type) {
        if (type === 'clickNum') {
          // 打开列表页弹框
          this.title = this.cardObj.title;
        } else {
          // 打开创建/编辑弹窗
          if (this.cardId) {
            this.title = this.$t('host.k_591006');
          } else {
            this.title = this.$t('host.k_591007');
          }
        }
      },
      saveSuccess() {
        this.showCreate = false;
        this.$refs.pushCards?.getCardList();
      },
      reload() {
        // 刷新当前列表
        this.$refs.pushCards?.getCardList();
      },
      /**
       * 对话框打开事事件
       */
      open() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.showCreate = false;
        this.CardClick = false;
      },
      handleCard(flag) {
        flag ? this.open() : this.handleClose();
      },
      handleChangeView() {
        this.showCreate = false;
        this.CardClick = false;
      },
      setChatItemData(msg, eventType) {
        const cardData = msg.data.card_info;
        return {
          nickname: cardData.operator,
          avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
          content: {
            text_content: this.$t('card.card_1003'),
            card_id: cardData.id,
            card_title: cardData.title || ''
          },
          roleName: cardData.role_name,
          type: eventType,
          interactStatus: true, // 消息样式 - 互动消息样式 还是 系统消息样式
          isCheck: false, // 消息是否-允许点击
          isLinkBtn: false // 是否具备点击查看等操作（发起端/PC观看端card特殊化）
        };
      },
      // 主持端、助理、嘉宾可能会都在线操作，需要消息互通处理
      handleRoomMsg(msg) {
        // 监听推送卡片消息
        if (msg.data.type == 'push_screen_card') {
          let info = this.setChatItemData(msg, msg.data.type);
          useChatServer().addChatToList(info);
          // prettier-ignore
          if (msg.sender_id && (this.userId == msg.sender_id || this.userId == `visit_${msg.sender_id}`)) {
              // 如果是自己发送的消息,不刷新
              console.log('自己发送的消息,不刷新1');
              return;
            }
          this.reload();
        }
        // 推送卡片取消
        else if (msg.data.type == 'push_screen_card_cancel') {
          // prettier-ignore
          if (msg.sender_id && (this.userId == msg.sender_id || this.userId == `visit_${msg.sender_id}`)) {
              // 如果是自己发送的消息,不刷新
              console.log('自己发送的消息,不刷新2');
              return;
            }
          this.reload();
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  ::v-deep .vmp-card-dialog {
    .reload {
      font-size: 14px;
      margin-left: 4px;
    }
    .vh-dialog__body {
      height: 524px;
      overflow-y: scroll;
      padding-bottom: 0;
    }
    .title-container {
      display: flex;
      align-items: center;
      font-size: 18px;
    }
    .dialog-title {
      display: inline-block;
    }
    .card-head-title {
      font-size: 20px;
      color: #1a1a1a;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
  }
</style>
